import { BaseDto } from "@/shared/dtos/base-dto";

export class contador extends BaseDto {
  public digitos!: number;
  public proximo_numero!: number;
  public id_planes!: number;
  public id_ambitos!: number;
}
